import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';

export const getAutomateInterpretationList = createAsyncThunk('interpretation_authmate', async () => {
    try {
        const { data } = await ax.post(`md_management/automate_mdata`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.message;
        }
    }
});

// md_management/phq_mdata
export const getPhqQues = createAsyncThunk('phq_master_data', async () => {
    try {
        const { data } = await ax.post(`md_management/phq_mdata`);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.message;
        }
    }
});

// add_phq
export const addPhqQues = createAsyncThunk('add_phq_master_data', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`md_management/add_phq`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const delPhqQues = createAsyncThunk('delete-phq_master', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post('md_management/remove_phq', payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.response);
        }
    }
})